import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'
import { MAINTENANCE_QUERY_KEY } from './useQueryMaintenanceMode'

interface SetMaintenancePayload {
  isActive: boolean
  message: string
}

export function useMutationMaintenanceMode() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: SetMaintenancePayload) =>
      axiosInstance.post('/config-api/system/maintenance', payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MAINTENANCE_QUERY_KEY })
    },
  })
}
